import Head from "next/head";
import { Container } from "~/components/layout/Container";
import Image from "next/image";

import { type ReactElement } from "react";
import { NextSeo } from "next-seo";
import Link from "next/link";
import { getZendeskLoginUrl } from "~/utils";
import { AuthenticationService } from "~/type/Auth";
import { env } from "~/env.mjs";

const AppLogin = () => {
  return (
    <>
      <NextSeo title="Valt Login" nofollow={true} noindex={true} />
      <Head>
        <title>RFOX VALT | Login</title>
      </Head>
      <Container>
        <div className="Container relative mx-auto mt-20 flex h-screen w-full justify-center">
          <Image
            src="/images/login-pattern.webp"
            alt="login-pattern-rfox-valt"
            width={400}
            height={400}
            priority={true}
            className="hidden h-[50%] w-auto md:block md:h-3/5"
          />
          <div className="center absolute mx-4 h-fit items-center rounded-lg bg-dark-200 px-10 py-10 md:px-16 md:py-16">
            <h3 className="text-center text-2xl font-bold italic leading-6 text-light-50 md:text-4xl">
              Connect Your Account
            </h3>
            <p className="mt-2 max-w-2xl text-center text-sm text-light-250 md:mt-4  md:text-base">
              Login/ Sign up to RFOX ID With Your Favorite Social Media Account
            </p>

            <Image
              src="/images/rfox-id.svg"
              alt="rfox-id"
              width={366}
              height={106}
              className="mx-auto mt-6 w-36"
            />

            <div className="mx-auto mt-2 flex flex-row justify-center gap-4">
              <Link
                href={getZendeskLoginUrl(AuthenticationService.GOOGLE)}
                className="flex items-center justify-center rounded-md bg-light-200 p-2 px-8"
              >
                <Image
                  src="/images/google.svg"
                  alt="rfox-id-google"
                  width={20}
                  height={20}
                  className="mx-auto h-7 w-7"
                />
              </Link>
              {env.NEXT_PUBLIC_FACEBOOK_LOGIN && (
                <Link
                  href={getZendeskLoginUrl(AuthenticationService.FACEBOOK)}
                  className="flex items-center justify-center rounded-md bg-blue-500 p-2 md:px-8"
                >
                  <Image
                    src="/images/facebook.svg"
                    alt="rfox-id-facebook"
                    width={20}
                    height={20}
                    className="mx-auto h-7 w-7"
                  />
                </Link>
              )}
              <Link
                href={getZendeskLoginUrl(AuthenticationService.APPLE)}
                className="flex items-center justify-center rounded-md bg-slate-200 p-2 px-8"
              >
                <Image
                  src="/images/apple.svg"
                  alt="rfox-id-apple"
                  width={20}
                  height={20}
                  className="mx-auto h-7 w-7"
                />
              </Link>
              {env.NEXT_PUBLIC_EMAIL_LOGIN && (
                <button
                  className="flex items-center justify-center rounded-md bg-dark-100 p-2 disabled:opacity-20"
                  disabled
                >
                  <Image
                    src="/images/email.svg"
                    alt="rfox-id-passwordless"
                    width={20}
                    height={20}
                    className="mx-auto h-7 w-7"
                  />
                </button>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

AppLogin.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default AppLogin;
